// MODULES
export const MODULE_TASKS = 'TASKS'
export const MODULE_TASKS_V2 = 'TASKSV2'
export const MODULE_SUBSTITUTES = 'SUBSTITUTE'
export const MODULE_REMOTE_VIEW = 'MEEKIJKENV2'
export const MODULE_CITO = 'CITO'
export const MODULE_STORAGE = 'STORAGE'
export const MODULE_GROUPS = 'GROUPS'
export const MODULE_SETTINGS = 'SETTINGS'
export const MODULE_STORE = 'STORE'
export const MODULE_MOMENTO = 'MOMENTO'
export const MODULE_DASHBOARD = 'DASHBOARD'
export const MODULE_LIBRARY = 'LIBRARY'
export const MODULE_LINKS = 'LINKS'
export const MODULE_HELP = 'HELP'
export const MODULE_EDITOR = 'EDITOR'
export const MODULE_WIZENOZE = 'WIZENOZE'
export const MODULE_TEAMS_MANAGEMENT = 'TEAMSMANAGEMENT'
export const MODULE_MESSAGES = 'MESSAGES'
